import _ from 'lodash';

type QueryParams = string | string[] | object
type SearchQueryTypes<T> = {[K in keyof T]?: SearchQueryType<T[K]>}
type SearchQueryGenerateObject<T> = Required<{[K in keyof T]: (v?: SearchQueryType<T[K]>) => T[K]}>
type SearchQueryType<T> = T extends number ? QueryParams : SearchQueryNestType<T>
type SearchQueryNestType<T> = {[K in keyof T]?: (T[K] extends object ? SearchQueryNestType<T[K]> : QueryParams)}

export const convertQueryoTypePreservingObject = <T>(
  keyArray: (keyof T)[],
  generateObject: SearchQueryGenerateObject<T>,
  searchStr: string = location.search
) => {
  const searchParams = new URLSearchParams(searchStr)

  const params = _.chain(keyArray)
  .map((key) => [key, searchParams.get(key as string)])
  .reject(([key, value]) => !value)
  .fromPairs()  
  .value() as SearchQueryTypes<T>

  return convertParams<T>(params, generateObject);
};

export const convertParams = <T extends Partial<{[K in keyof T]: T[K]}>>(
  params: SearchQueryTypes<T>,
  generateObject: SearchQueryGenerateObject<T>
) => {
  const newParams = {} as {[K in keyof T]?: T[K]}

  for(const vKey in params) {
    const generateFunction = generateObject[vKey]
    newParams[vKey] = generateFunction ? generateFunction(params[vKey]) : undefined
  }

  return newParams
}

export const convertQueryParamsToString = (v?: QueryParams) => typeof v === 'string' ? v : ''

export const convertQueryParamsToNumber = (v?: QueryParams) => typeof v === 'string' ? parseFloat(v) : undefined
